import { render, staticRenderFns } from "./PageContentSections.vue?vue&type=template&id=600d0707&scoped=true"
import script from "./PageContentSections.vue?vue&type=script&lang=js"
export * from "./PageContentSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d0707",
  null
  
)

export default component.exports